import React, { useEffect, useRef } from 'react'
import { useCountUp } from 'react-countup'
import Image from '../../function/Image'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import parse from 'html-react-parser'

gsap.registerPlugin(ScrollTrigger)
const StatisticBlock = ({ statisticsBlock }) => {
    const quoteRef = useRef(null)
    const {
        background,
        imageBackground,
        name,
        quote,
        role,
        stats,
        title,
        visibility
    } = statisticsBlock || {}
    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.fromTo(
                '.image-parallax',
                { yPercent: -20 },
                {
                    yPercent: 20,
                    scrollTrigger: {
                        trigger: quoteRef?.current,
                        scrub: true,
                        // markers: true,
                        start: "top bottom-=10%",
                        end: "bottom +=10%"
                    },
                    ease: "none"
                }
            )
        }, quoteRef)

        return () => {
            ctx.revert()
        }
    }, [])

    const backgroundStyles = (background) => {
        if (!background) return  {background :'transparent'}

        if (background?.solidColor) {
            return { backgroundColor: background?.solidColor }
        }

        if (
            background?.gradientColor?.firstColor &&
            background?.gradientColor?.secondColor
        ) {
            return {
                background: `transparent linear-gradient(106deg, ${background?.gradientColor?.firstColor} 0%, ${background?.gradientColor?.secondColor} 100%) 0% 0% no-repeat padding-box`
            }
        }
    }

    return (
        <>
            <div
                className={`text-white  relative ${
                    visibility
                        ? 'pt-20 pb-40 lg:pt-[88px] lg:pb-[265px]'
                        : 'py-20 lg:py-[88px]'
                }`}
            >
                <div
                    className="absolute top-0 bottom-0 z-[-1] w-screen left-1/2 -translate-x-1/2"
                    style={backgroundStyles(background)}
                ></div>
                <div className="container">
                    {title && (
                        <span className="block mb-[51px] font-[FoundersGrotesk-Bold] text-2xl lg:text-3xl">
                            {title}
                        </span>
                    )}

                    <div className="flex flex-col gap-y-5 md:flex-row md:justify-between md:gap-x-5">
                        {stats?.map((stat, index) => {
                            return <StatItem stat={stat} key={index} />
                        })}
                    </div>
                </div>
            </div>

            {visibility && (
                <div
                    className="container client-quote -mt-[100px] lg:-mt-[214px]"
                    ref={quoteRef}
                >
                    <div className="grid grid-cols-12 gap-x-2 text-white rounded-[10px] overflow-hidden relative xl:gap-x-7">
                        <div
                            className="absolute inset-0 -z-[-1]"
                            style={{
                                background:
                                    ' linear-gradient(89deg, #000000 0%, #00000000 100%) 0% 0% no-repeat padding-box'
                            }}
                        ></div>
                        <div className="absolute inset-0 -z-[1]">
                            <div className="image-parallax w-full h-full scale-[1.4]">
                                {imageBackground && (
                                    <Image {...imageBackground} />
                                )}
                            </div>
                        </div>
                        <div className="col-span-10 relative z-10 col-start-2 py-10 md:py-20 xl:col-start-2 xl:pb-[80px] xl:pt-[80px] xl:pr-[40px]">
                            <span className="text-7xl block font-[FoundersGrotesk-Bold] leading-none xl:text-[100px]">
                                “
                            </span>
                            {quote && (
                                <p className="mb-[18px] !-mt-2 text-xl font-[FoundersGrotesk-Bold]">
                                    {quote}
                                </p>
                            )}

                            {name && (
                                <p className="font-bold text-[17px] mb-[10px]">
                                    {name}
                                </p>
                            )}
                            {role && (
                                <span className="font-[FoundersGrotesk-Bold] font-bold text-xs uppercase tracking-[2px] block text">
                                    {role}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default StatisticBlock

const StatItem = ({ stat }) => {
    let front = ''
    let end = ''

    const countUpRef = useRef(null)
    useCountUp({
        ref: countUpRef,
        end: stat?.number,
        enableScrollSpy: true,
        scrollSpyDelay: 500,
        scrollSpyOnce: true
    })

    if (stat?.unit === '%') {
        end = stat?.unit
    }
    if (stat?.unit === '+') {
        front = stat?.unit
    }

    if (stat?.unit === 'Other') {
        if (stat?.unitPosition) {
            front = stat?.unitSymbol
        } else end = stat?.unitSymbol
    }

    return (
        <div className="py-3 pl-5 relative md:flex-1">
            <div className="absolute top-0 bottom-0 w-1 rounded bg-white left-0"></div>
            {stat?.number && (
                <span className="text-6xl block !font-[FoundersGrotesk-Bold] font-bold mb-1">
                    <span>{front}</span>
                    <span ref={countUpRef} />
                    <span className="text-[40px] align-top">{end}</span>
                </span>
            )}
            {stat?.text && (
                <div className="text-6xl block !font-[FoundersGrotesk-Bold] font-bold mb-1">
                    {parse(stat?.text)}
                </div>
            )}

            {stat?.description && (
                <p className="font-[FoundersGrotesk-Regular]">
                    {stat?.description}
                </p>
            )}
        </div>
    )
}
